{
  "alert": {
    "blurb": "Уведомление для привлечения внимания пользователя.",
    "name": "Предупреждение"
  },
  "button": {
    "blurb": "Кликабельный элемент, выполняющий действие при нажатии.",
    "default": "По умолчанию",
    "loading": "Загрузка...",
    "name": "Кнопка",
    "send": "Отправить"
  },
  "components": {
    "name": "Компоненты",
    "title": "Компоненты"
  },
  "form": {
    "blurb": "Демонстрация всех компонентов ввода, включенных в этот шаблон.",
    "name": "Форма",
    "title": "Форма"
  },
  "orgName": "Разработка Mindsea",
  "title": "Песочница компонентов"
}
